export default "__VITE_ASSET__CenExsxe__"